import { GETREQUESTOPTIONS, instance } from '../apiService';

export type VariableType = 'fixed' | 'ref';

export interface Variable {
    type: VariableType;
    name: string;
    label?: string;
    fixedValue?: string;
    refTarget?: string;
    refId?: string;
}

export interface CreateVariableInput {
    type: VariableType;
    name: string;
    label?: string;
    fixedValue?: string;
    refTarget?: string;
    refId?: string;
}

export interface UpdateVariableInput {
    type: VariableType;
    label?: string;
    fixedValue?: string;
    refTarget?: string;
    refId?: string;
}

export interface UpsertStepVariablesInput {
    variables: CreateVariableInput[];
}

export type DepartmentVariableField =
    | 'text'
    | 'number'
    | 'boolean'
    | 'textarea'
    | 'ref';

export interface DepartmentVariableTemplateItem {
    field: DepartmentVariableField;
    name: string;
    refTarget?: string;
    required?: boolean;
}

export interface DepartmentVariableTemplateSection {
    key: string;
    variables: DepartmentVariableTemplateItem[];
}

export interface DepartmentVariableCompletion {
    missingRequired: string[];
    isComplete: boolean;
}

export const getDepartmentVariables = async (): Promise<Variable[]> => {
    const res = await instance.get(
        '/api/department-variables',
        GETREQUESTOPTIONS()
    );
    return res.data;
};

export const createVariable = async (
    input: CreateVariableInput
): Promise<Variable[]> => {
    const res = await instance.post(
        '/api/department-variables/variable',
        input,
        GETREQUESTOPTIONS()
    );
    return res.data;
};

export const updateVariable = async (
    name: string,
    input: UpdateVariableInput
): Promise<Variable[]> => {
    const res = await instance.put(
        `/api/department-variables/variable/${encodeURIComponent(name)}`,
        input,
        GETREQUESTOPTIONS()
    );
    return res.data;
};

export const upsertDepartmentVariableStep = async (
    stepKey: string,
    input: UpsertStepVariablesInput
): Promise<Variable[]> => {
    const res = await instance.put(
        `/api/department-variables/step/${encodeURIComponent(stepKey)}`,
        input,
        GETREQUESTOPTIONS()
    );
    return res.data;
};

export const removeVariable = async (name: string): Promise<void> => {
    await instance.delete(
        `/api/department-variables/variable/${encodeURIComponent(name)}`,
        GETREQUESTOPTIONS()
    );
};

export const resolveVariables = async (): Promise<Record<string, string>> => {
    const res = await instance.get(
        '/api/department-variables/resolve',
        GETREQUESTOPTIONS()
    );
    return res.data;
};

export const getDepartmentVariableTemplate = async (): Promise<
    DepartmentVariableTemplateSection[]
> => {
    const res = await instance.get(
        '/api/department-variables/template',
        GETREQUESTOPTIONS()
    );
    return res.data;
};

export interface AffectedPolicy {
    _id: string;
    title?: string;
    status?: string;
}

export const getAffectedPolicies = async (
    variableName: string
): Promise<AffectedPolicy[]> => {
    const res = await instance.get(
        `/api/department-variables/variable/${encodeURIComponent(variableName)}/affected-policies`,
        GETREQUESTOPTIONS()
    );
    return res.data.policies;
};

export const getDepartmentVariableCompletion = async (): Promise<DepartmentVariableCompletion> => {
    const res = await instance.get(
        '/api/department-variables/completion',
        GETREQUESTOPTIONS()
    );
    return res.data;
};
